import React, { useState, useEffect, forwardRef } from 'react';

interface ProgressiveImgProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  placeholderSrc: string;
  src: string;
}

const ProgressiveImg = forwardRef<HTMLImageElement, ProgressiveImgProps>(
  ({ placeholderSrc, src, className, ...props }, ref) => {
    const [ imgSrc, setImgSrc ] = useState(placeholderSrc);

    useEffect(() => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        setImgSrc(src);
      };
    }, [ src ]);

    const loadingClass = placeholderSrc && imgSrc === placeholderSrc
      ? "loading"
      : "loaded";

    return (
      <img
        {...props}
        ref={ref}
        src={imgSrc}
        className={`image ${loadingClass} ${className || ''}`}
      />
    );
  }
);

// Add display name for dev tools
ProgressiveImg.displayName = 'ProgressiveImg';

export default ProgressiveImg;